import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  PurchaseOrderDetailCreateRequestDTO,
  PurchaseOrderDetailUpdateRequestDTO,
  PurchaseOrderDetailDeleteRequestDTO,
  PurchaseOrderDetailReadByIdRequestDTO,
  PurchaseOrderDetailReadByPurchaseOrderIdRequestDTO,
  PurchaseOrderDetailReadByPurchaseOrderIdForImportRequestDTO,
  PurchaseOrderDetailReadbyItemIdRequestDTO,
  PurchaseOrderDetailDTO,
  PurchaseOrderDetailList,
  PurchaseOrderDetailCreateBulkRequestDTO,
  PurchaseOrderDetailUpsertBulkRequestDTO
} from './purchase-order-detail.interface';

import {
  PurchaseOrderDetail_Create,
  PurchaseOrderDetail_Update,
  PurchaseOrderDetail_Delete,
  PurchaseOrderDetail_ReadById,
  PurchaseOrderDetail_ReadByPurchaseOrderId,
  PurchaseOrderDetail_ReadByPurchaseOrderIdForImport,
  PurchaseOrderDetail_ReadByItemId,
  PurchaseOrderDetail_CreateBulk,
  PurchaseOrderDetail_UpsertBulk
} from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderDetailService {

  http = inject(HttpClient);

  PurchaseOrderDetail_Create(data: PurchaseOrderDetailCreateRequestDTO ): Observable<PurchaseOrderDetailDTO> {
    return this.http.post<PurchaseOrderDetailDTO>(PurchaseOrderDetail_Create, data);
  }

  PurchaseOrderDetail_Update(data: PurchaseOrderDetailUpdateRequestDTO): Observable<PurchaseOrderDetailDTO> {
    return this.http.post<PurchaseOrderDetailDTO>(PurchaseOrderDetail_Update, data);
  }

  PurchaseOrderDetail_Delete(data: PurchaseOrderDetailDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(PurchaseOrderDetail_Delete, data);
  }

  PurchaseOrderDetail_ReadById(data: PurchaseOrderDetailReadByIdRequestDTO): Observable<PurchaseOrderDetailDTO> {
    return this.http.post<PurchaseOrderDetailDTO>(PurchaseOrderDetail_ReadById, data);
  }

  PurchaseOrderDetail_ReadByPurchaseOrderId(data: PurchaseOrderDetailReadByPurchaseOrderIdRequestDTO): Observable<PurchaseOrderDetailList> {
    return this.http.post<PurchaseOrderDetailList>(PurchaseOrderDetail_ReadByPurchaseOrderId,data);
    // return this.http.post<PurchaseOrderDetailList>("https://dev.ms.vnccy.com/ERP/Billing/PurchaseOrderDetail/ReadByPurchaseOrderId",data);
  }

  PurchaseOrderDetail_ReadByPurchaseOrderIdForImport(data: PurchaseOrderDetailReadByPurchaseOrderIdForImportRequestDTO): Observable<PurchaseOrderDetailList> {
    return this.http.post<PurchaseOrderDetailList>(PurchaseOrderDetail_ReadByPurchaseOrderIdForImport, data);
  }

  PurchaseOrderDetail_ReadByItemId(data: PurchaseOrderDetailReadbyItemIdRequestDTO): Observable<PurchaseOrderDetailList> {
    return this.http.post<PurchaseOrderDetailList>(PurchaseOrderDetail_ReadByItemId,data);
  }

  PurchaseOrderDetail_CreateBulk(data: PurchaseOrderDetailCreateBulkRequestDTO): Observable<void> {
    return this.http.post<void>(PurchaseOrderDetail_CreateBulk, data);
  }

  PurchaseOrderDetail_UpsertBulk(data: PurchaseOrderDetailUpsertBulkRequestDTO): Observable<PurchaseOrderDetailList> {
    return this.http.post<PurchaseOrderDetailList>(PurchaseOrderDetail_UpsertBulk, data);
  }
}
